// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".commercial-decision-warning[data-v-41f0ff02] {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--v-warning-base);\n  border-radius: 8px;\n  background: rgba(255, 193, 7, 0.12);\n  color: var(--v-gray_90-base);\n  font-size: 14px;\n  line-height: 1.45;\n}", ""]);
// Exports
module.exports = exports;
